module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cv.json
// module id = 337
// module chunks = 52306936332150